import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['pane', 'tab'];

  connect() {
    this._hideAllPanes();
    this._showPane(this.paneTarget);
  }

  get hideClass() {
    return this.data.get('hide-with');
  }

  changeTab(event) {
    event.preventDefault();
    this._hideAllPanes();

    const paneName = event.target.dataset.tabsPane;
    const pane = this.paneTargets.find(
      pane => pane.dataset.tabsPane === paneName
    );
    this._showPane(pane);
  }

  _hideAllPanes() {
    this.paneTargets.forEach(pane => this._hidePane(pane));
  }

  _hidePane(pane) {
    pane.classList.add(this.hideClass);
  }

  _showPane(pane) {
    pane.classList.remove(this.hideClass);
  }
}
